<template>
  <div
    v-loading.fullscreen.lock="fullscreenLoading"
    class="verify-box"
    style="width:500px;"
  >
    <el-dialog
      title=""
      :visible="true"
      :before-close="onCloseDialog"
      :close-on-click-modal="false"
    >
      <el-form>
        <el-form-item v-if="action_type == 2" label="">
          <span style="font-size: 18px"
            >从一手商家子账户提现至所绑定的银行卡</span
          >
        </el-form-item>
        <el-form-item v-if="action_type == 1" label="">
          <span style="font-size: 18px">从挂账账户充值至一手商家子账户</span>
        </el-form-item>
        <el-form-item v-if="action_type == 2" label="收款银行:">
          <span>{{ base[0].bank_no }}</span>
        </el-form-item>
        <el-form-item v-if="action_type == 1" label="挂账余额:">
          <span>{{ base[0].gz_money }}</span>
        </el-form-item>

        <el-form-item v-if="action_type == 1" label="充值金额:">
          <el-input
            v-model="form.recharge_money"
            type="number"
            style="width: 80%"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="action_type == 2" label="提现金额:">
          <el-input
            v-model="form.cash_money"
            type="number"
            style="width: 80%"
          ></el-input>
        </el-form-item>
        <el-form-item label="后台账号:">
          <span>{{ $cookie.get("username") }}</span>
        </el-form-item>
        <el-form-item label="后台密码:">
          <el-input
            v-model="form.password"
            type="password"
            placeholder="请输入密码"
            style="width: 80%"
          ></el-input>
        </el-form-item>
        <el-form-item label="验证码: ">
          <el-input
            v-model="phoneCode"
            class="el-dialog-col--small"
            placeholder="请输入手机验证码"
            style="width: 60%"
          ></el-input>
          <el-button
            type="primary"
            class="code-btn"
            :disabled="!show"
            style="margin-bottom: 10px;"
            @click="sendsms()"
          >
            <span v-show="show">获取短信验证码</span>
            <span v-show="!show" class="count">{{ count }} s</span>
          </el-button>
        </el-form-item>
        <!--                <el-form-item label="用途:">-->
        <!--                    <el-input v-model="form.furinfo" placeholder="请输入用途" style="width: 80%"></el-input>-->
        <!--                </el-form-item>-->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onCloseDialog">取 消</el-button>
        <el-button type="primary" @click="do_action()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import md5 from "js-md5";
const TIME_COUNT = 60;
export default {
  props: {
    url: {
      type: String,
      default: 0,
    },
    base: {
      type: Array,
      default: 0,
    },
    action_type: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      form: {
        password: "",
      },
      loading: false,
      shipping_num: "",
      show: true,
      count: "",
      timer: null,
      phoneCode: "",
      fullscreenLoading: false,
    };
  },
  mounted() {
    this.filterData();
  },
  methods: {
    filterData() {},
    do_action() {
      if (this.pay_num == 0) {
        this.$message.error("请选择订单");
        this.onCloseDialog();
      } else {
        this.fullscreenLoading = true;
        this.form.code = this.phoneCode;
        this.$http.post(this.url, this.form).then(res => {
          this.fullscreenLoading = false;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.$message.success(res.data.msg);
            this.onCloseDialog();
          }
        });
      }
    },
    sendsms() {
      let url = "/erp/Admin/sendSmsByPwd";
      let args = {
        name: this.$cookie.get("username"),
        password: md5(this.form.password),
        type: 3,
      };

      this.$http.post(url, args).then(res => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.$message.success(res.data.msg);
          this.timecount();
        }
      });
    },
    timecount() {
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    onCloseDialog() {
      this.$emit("onCloseDialog", false);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/pacashlog/components/CashAndRecharge.vue